import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import * as $ from 'jquery';
import { config } from 'rxjs/Rx';

import { AgmCoreModule } from '@agm/core';
import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AdminService } from './_services/admin.service';
import { CrmPostService } from './_services/crm-post.service';
import { ReportingService } from './_services/reporting.service';
import { UserBoardService } from './_services/user-board.service';
import { UtilsService } from './_utils/utils.service';
import { NgbDateCustomParserFormatter } from './_utils/ngb-date-custom-formatter';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { OneColumnLayoutComponent } from './layouts/1-column-layout/1-column-layout.component';
import { TwoColumnsLayoutComponent } from './layouts/2-columns-layout/2-columns-layout.component';
import { AccountComponent } from './layouts/account/account.component';
import { AdminComponent } from './layouts/admin/admin.component';
import { AllReportsComponent } from './layouts/all-reports/all-reports.component';
import { BoxedLayoutComponent } from './layouts/boxed-layout/boxed-layout.component';
import { DarkLayoutComponent } from './layouts/dark-layout/dark-layout.component';
import {
    DetachedLeftSidebarLayoutComponent
} from './layouts/detached-left-sidebar-layout/detached-left-sidebar-layout.component';
import {
    DetachedRightSidebarLayoutComponent
} from './layouts/detached-right-sidebar-layout/detached-right-sidebar-layout.component';
import {
    DetachedStickyLeftSidebarLayoutComponent
} from './layouts/detached-sticky-left-sidebar-layout/detached-sticky-left-sidebar-layout.component';
import {
    DetachedStickyRightSidebarLayoutComponent
} from './layouts/detached-sticky-right-sidebar-layout/detached-sticky-right-sidebar-layout.component';
import { FeaturedEventComponent } from './layouts/featured-event/featured-event.component';
import { FixedLayoutComponent } from './layouts/fixed-layout/fixed-layout.component';
import {
    FixedNavbarFooterLayoutComponent
} from './layouts/fixed-navbar-footer-layout/fixed-navbar-footer-layout.component';
import {
    FixedNavbarLayoutComponent
} from './layouts/fixed-navbar-layout/fixed-navbar-layout.component';
import {
    FixedNavbarNavigationLayoutComponent
} from './layouts/fixed-navbar-navigation-layout/fixed-navbar-navigation-layout.component';
import {
    FixedNavigationLayoutComponent
} from './layouts/fixed-navigation-layout/fixed-navigation-layout.component';
import { LightLayoutComponent } from './layouts/light-layout/light-layout.component';
import { MembersComponent } from './layouts/members/members.component';
import { MessagesHistoryComponent } from './layouts/messages-history/messages-history.component';
import { MessagesComponent } from './layouts/messages/messages.component';
import {
    NonFeaturedEventComponent
} from './layouts/non-featured-event/non-featured-event.component';
import {
    PersonalTrainersEventsComponent
} from './layouts/personal-trainers-events/personal-trainers-events.component';
import { PersonalTrainersComponent } from './layouts/personal-trainers/personal-trainers.component';
import { SemiDarkLayoutComponent } from './layouts/semi-dark-layout/semi-dark-layout.component';
import { SettingsComponent } from './layouts/settings/settings.component';
import { StaticLayoutComponent } from './layouts/static-layout/static-layout.component';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { AuthService } from './shared/auth/auth.service';
import { RoleGuard } from './shared/auth/role-guard.service';
import { SharedModule } from './shared/shared.module';
import { SignUpModule } from './components/sign-up/sign-up.module';

const configDev = {
  apiKey: 'AIzaSyCSStzR1Gj4D0q-vDWMGqgT4hbFVnY5BnI',
  authDomain: 'gogymbuddy-dev.firebaseapp.com',
  databaseURL: 'https://gogymbuddy-dev.firebaseio.com',
  projectId: 'gogymbuddy-dev',
  storageBucket: 'gogymbuddy-dev.appspot.com',
  messagingSenderId: '467333018802'
}

const configMaster = {
  apiKey: 'AIzaSyDp6FVwJz6BpV6ik7BtEA_fZSwsyfWkObo',
  authDomain: 'gogymbuddy.firebaseapp.com',
  databaseURL: 'https://gogymbuddy.firebaseio.com',
  projectId: 'gogymbuddy',
  storageBucket: 'gogymbuddy.appspot.com',
  messagingSenderId: '22166376395'
}


@NgModule({
  declarations: [
    AccountComponent,
    AdminComponent,
    AllReportsComponent,
    AppComponent,
    BoxedLayoutComponent,
    DarkLayoutComponent,
    DetachedLeftSidebarLayoutComponent,
    DetachedRightSidebarLayoutComponent,
    DetachedStickyLeftSidebarLayoutComponent,
    DetachedStickyRightSidebarLayoutComponent,
    FeaturedEventComponent,
    FixedLayoutComponent,
    FixedNavbarFooterLayoutComponent,
    FixedNavbarLayoutComponent,
    FixedNavbarNavigationLayoutComponent,
    FixedNavigationLayoutComponent,
    LightLayoutComponent,
    MembersComponent,
    MessagesComponent,
    MessagesHistoryComponent,
    NonFeaturedEventComponent,
    OneColumnLayoutComponent,
    PersonalTrainersComponent,
    PersonalTrainersEventsComponent,
    SemiDarkLayoutComponent,
    SettingsComponent,
    SignInComponent,
    StaticLayoutComponent,
    TwoColumnsLayoutComponent,
  ],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyC4OC_5ip3HTcTMqu_-yp4vpZW3zDxhsUw',
      libraries: ['places']
    }),
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(configMaster),
    AngularFireAuthModule,
    FormsModule,
    AngularFireStorageModule,
    NgbModule.forRoot(),
    HttpClientModule,
    SignUpModule
  ],
  providers: [
    AdminService,
    AuthGuard,
    AuthService,
    CrmPostService,
    DatePipe,
    ReportingService,
    RoleGuard,
    UserBoardService,
    UtilsService,
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts